export const FETCH = 'feeds/FETCH';
export const FETCH_SUCCESS = 'feeds/FETCH_SUCCESS';
export const FETCH_ERROR = 'feeds/FETCH_ERROR';
